/**
 * The service worker's copy of the API's reads (vite.config.ts, `runtimeCaching`): what the app
 * shows offline. Named here so the worker that fills it and the sign-out that empties it agree.
 */
export const API_CACHE = 'damis-api'

/** Drop every cached API response on this device: called when a session ends. */
export function forgetCachedResponses(): void {
  if (typeof caches === 'undefined') return
  void caches.delete(API_CACHE)
}
